import { useState } from "react";
import styles from './CashFlow.module.css'
import { ArrowUpRight, Calendar } from 'react-feather';
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import axios from "axios";
import { useHistory } from "react-router-dom";
import { DashCardLoaderSmall } from "../../../../../components/LoaderC";
import dayjs from "dayjs";

const CashFlow = ({ selectedProperty }) => {
  const redirect = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [contentLoading1, setContentLoading1] = useState(true);
  const [contentLoading2, setContentLoading2] = useState(true);
  const [incomeList, setIncomeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [noData1, setNoData1] = useState(true);
  const [noData2, setNoData2] = useState(true);
  const [currentMonth, setCurrentMonth] = useState(dayjs().format('YYYY-MM'));

  useEffect(() => {
    const fetchData = async () => {
      setContentLoading1(true);
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      var URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/income-by-categories";
      if (currentMonth !== '') {
        URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/income-by-categories?month=" + currentMonth;
        if (selectedProperty !== '' && selectedProperty > 0) {
          URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/income-by-categories?month=" + currentMonth + "&property_id=" + selectedProperty;
        }
      } else {
        if (selectedProperty !== '' && selectedProperty > 0) {
          URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/income-by-categories?property_id=" + selectedProperty;
        }
      }

      await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading1(false);

        let respData = response.data.data;
        setTotalIncome(respData?.total);
        setIncomeList(respData?.categories.slice(0, 5));

        if (respData?.categories?.length > 0) {
          setNoData1(false);
        } else {
          setNoData1(true);
        }
      }).catch(() => {
        setContentLoading1(false);
        setNoData1(true);
      });
    }

    fetchData();
  }, [getAccessTokenSilently, selectedProperty, currentMonth]);

  useEffect(() => {
    const fetchData = async () => {
      setContentLoading2(true);
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      var URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/expense-by-categories";
      if (currentMonth !== '') {
        URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/expense-by-categories?month=" + currentMonth;
        if (selectedProperty !== '' && selectedProperty > 0) {
          URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/expense-by-categories?month=" + currentMonth + "&property_id=" + selectedProperty;
        }
      } else {
        if (selectedProperty !== '' && selectedProperty > 0) {
          URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/expense-by-categories?property_id=" + selectedProperty;
        }
      }

      await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading2(false);
        let respData = response.data.data;

        setTotalExpense(respData?.total);
        setExpenseList(respData?.categories.slice(0, 5));

        if (respData?.categories?.length > 0) {
          setNoData2(false);
        } else {
          setNoData2(true);
        }
      }).catch((error) => {
        setContentLoading2(false);
        setNoData2(true);
      });
    }

    fetchData();
  }, [getAccessTokenSilently, selectedProperty, currentMonth]);

  return (<>
    <div className={`${styles.CashFlowSec}`}>
      <div className={`${styles.CashFlowHeadSec}`}>
        <p className={`${styles.HeadTitle}`}>Cash Flow</p>
        <div className={`${styles.CashFlowFilterSec} DashFilterSec Filter NoBorder`}>
          <DatePicker
            oneTap
            editable={false}
            cleanable={false}
            format="MMM yyyy"
            placement={"bottomEnd"}
            caretAs={Calendar}
            defaultValue={dayjs().toDate()}
            onChange={(date) => {
              setCurrentMonth(dayjs(date).format('YYYY-MM'));
            }}
          />
        </div>
      </div>
      <div className={`${styles.CashFlowRow}`}>

        <div className={`${styles.CashFlowCard}`}>
          {contentLoading1 && (<div className={`${styles.LoaderDash3}`}>
            <div><DashCardLoaderSmall /></div>
          </div>)}

          {!contentLoading1 && (<>
            <div className={`${styles.CashFlowCardHead}`}>
              <p className={`${styles.CardHeadTitle}`}>Income</p>
              <p className={`${styles.CardHeadAmount} ${styles.Income}`}>{totalIncome?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
              })}</p>
            </div>
            {!noData1 && (<>
              <div className={`${styles.CashFlowCardBody}`}>
                <div className={`${styles.Width100}`}>
                  {incomeList?.map(item => {
                    return (<div className={`${styles.CardBodyList}`} onClick={(e) => { localStorage.setItem("incomeCategoryFilterData", item?.category_id); redirect.push("/income/all-income"); }}>
                      <div className={`${styles.FirstSec}`}>
                        <div><img src="/static/img/income-icon.svg" alt="" /></div>
                        <p>{item?.category_title}</p>
                      </div>
                      <p className={`${styles.CardBodyListAmount}`}>{item?.total_amount?.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                      })}</p>
                    </div>);
                  })}
                </div>
                <div className={`${styles.Width100}`}>
                  <div className={`${styles.CardBodyList} ${styles.ViewBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/income/all-income"); }}>
                    <div className={`${styles.FirstSec}`}>
                      <div><ArrowUpRight /></div>
                      <p>View All Income</p>
                    </div>
                  </div>
                </div>
              </div>
            </>)}

            {noData1 && (<>
              <div className={`${styles.NoDataSec}`}>
                <div className={`${styles.NoDataIMG}`}><img src="/static/img/income.png" alt="" /></div>
                <p className={`${styles.NoDataText}`}>No income recorded.</p>
                <p className={`${styles.NoDataTextSub}`}>Add income to see your overview.</p>
              </div>
            </>)}
          </>)}
        </div>

        <div className={`${styles.CashFlowCard}`}>
          {contentLoading2 && (<div className={`${styles.LoaderDash3}`}>
            <div><DashCardLoaderSmall /></div>
          </div>)}

          {!contentLoading2 && (<>
            <div className={`${styles.CashFlowCardHead}`}>
              <p className={`${styles.CardHeadTitle}`}>Expenses</p>
              <p className={`${styles.CardHeadAmount}`}>-{totalExpense?.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
              })}</p>
            </div>
            {!noData2 && (<>
              <div className={`${styles.CashFlowCardBody}`}>
                <div className={`${styles.Width100}`}>
                  {expenseList?.map(item => {
                    return (<div className={`${styles.CardBodyList}`} onClick={(e) => { localStorage.setItem("expenseCategoryFilterData", item?.category_id); redirect.push("/expense/all-expense"); }}>
                      <div className={`${styles.FirstSec}`}>
                        <div><img src="/static/img/expense-icon.svg" alt="" /></div>
                        <p>{item?.category_title}</p>
                      </div>
                      <p className={`${styles.CardBodyListAmount}`}>{item?.total_amount?.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                      })}</p>
                    </div>);
                  })}
                </div>
                <div className={`${styles.Width100}`}>
                  <div className={`${styles.CardBodyList} ${styles.ViewBU}`} onClick={(e) => { redirect.push("/expense/all-expense"); }}>
                    <div className={`${styles.FirstSec}`}>
                      <div><ArrowUpRight /></div>
                      <p>View All Expenses</p>
                    </div>
                  </div>
                </div>
              </div>
            </>)}

            {noData2 && (<>
              <div className={`${styles.NoDataSec}`}>
                <div className={`${styles.NoDataIMG}`}><img src="/static/img/expense.png" alt="" /></div>
                <p className={`${styles.NoDataText}`}>No expenses recorded.</p>
                <p className={`${styles.NoDataTextSub}`}>Add expense to see your overview.</p>
              </div>
            </>)}
          </>)}
        </div>

      </div>
    </div>
  </>);
}

export default CashFlow;